/**
 * Where the portal learns its Sentry config.
 *
 * Same contract as `apps/web` and the operator console: the served shell may
 * inject `window.__QUOVY_CONFIG__`. The portal shell currently injects `{}`
 * on purpose — it must not inherit the operator console's DSN/stack — so
 * build-time `VITE_*` values are the only source until a later change wires
 * a portal-specific runtime config.
 */

import { pick, readRuntimeConfig } from "@quovy/browser-telemetry";

const runtime = readRuntimeConfig();

export const SENTRY_DSN: string | undefined = pick(
  runtime.sentryDsn,
  import.meta.env.VITE_SENTRY_DSN,
);

export const SENTRY_ENVIRONMENT: string | undefined = pick(
  runtime.sentryEnvironment,
  import.meta.env.VITE_SENTRY_ENVIRONMENT,
);

export const STACK_NAME: string | undefined = pick(
  runtime.stackName,
  import.meta.env.VITE_STACK_NAME,
);
